import { FormControl, MenuItem, Select } from "@mui/material";

export interface IDropdownOption {
    label: string;
    value: string;
}

export interface IDropdownTableEdit {
    value: string;
    instalacaoId: number;
    propertyName: string;
    setDialogState?: any;
    setTableEditState?: any;
    options?: IDropdownOption[];
    onChange?: (value: string, instalacaoId: number) => void;
    selectWidth?: number;
}

const defaultOptions: IDropdownOption[] = [
    { label: "Sim", value: "Sim" },
    { label: "Não", value: "Não" },
];

const DropdownTableEdit = ({
    value,
    instalacaoId,
    setDialogState,
    setTableEditState,
    propertyName,
    options = defaultOptions,
    onChange,
    selectWidth = 130,
}: IDropdownTableEdit) => {
    const handleChange = (event) => {
        const newValue = event.target.value;

        if (onChange) {
            onChange(newValue, instalacaoId);
            return;
        }

        if (setDialogState && setTableEditState) {
            setDialogState(true);
            setTableEditState({ [propertyName]: newValue, clienteInstalacaoID: instalacaoId });
        }
    };

    return (
        <FormControl
            variant="standard"
            sx={{
                ".css-a3l6o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before": {
                    borderBottom: "none",
                },
                ".css-a3l6o-MuiInputBase-root-MuiInput-root-MuiSelect-root:hover": {
                    borderBottom: "none",
                },
            }}
        >
            <Select
                value={value || ""}
                onChange={handleChange}
                sx={{ width: `${selectWidth}px`, height: "50px", fontSize: "14px", marginTop: "2px" }}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DropdownTableEdit;
